import { runNewsroomInit } from '../common/newsroom-hub/newsroom-hub';

runNewsroomInit();
